(() => {
  const button = document.querySelector('[data-reserve-button]');
  let stickyButton = document.querySelector('[data-sticky-button]');

  const config = { attributes: true, childList: true, subtree: true };

  // Callback function to execute when mutations are observed
  const callback = (mutationList, observer) => {
    const interval = window.setInterval(() => {
      const reserve = document.querySelector('#digital-appointments-select-time-btn');
      if(!reserve) return;

      const reserveButton = reserve.querySelector('button');
      if(!reserveButton) return;

      stickyButton.innerHTML = reserveButton.innerHTML;

      stickyButton.outerHTML = `${stickyButton.outerHTML}`;
      stickyButton = document.querySelector('[data-sticky-button]');

      stickyButton.addEventListener('click', (event) => {
        event.preventDefault();
        const reserve = document.querySelector('#digital-appointments-select-time-btn');
        if(!reserve) return;

        const reserveButton = reserve.querySelector('button');
        if(!reserveButton) return;

        reserveButton.click();
      });

      window.clearInterval(interval);
      observer.disconnect();
    }, 100);
  };

  const observer = new MutationObserver(callback);

  observer.observe(button, config);
})();
